import React from 'react';
import { GridLoader } from 'react-spinners';
import styled from 'styled-components';

const LoaderDiv = styled.div`
height: 100vh;
width: 100%;
overflow: hidden;
display: flex;
justify-content: center;
align-items: center;
background: transparent;
position: absolute;
top: 50%;
transform: translate(0, -50%);
background: #00000073;
`

 const Loader = ( )=>{
return(
    <LoaderDiv>
    <GridLoader
  color="#F82F77"
  cssOverride={{}}
  loading
  margin={10}
  size={20}
  speedMultiplier={4}
  width={20}
/>
</LoaderDiv>
)
}
export default Loader;

